import React from 'react';
import { Text } from '@chakra-ui/react';

/**
 * Displays app version only. Shown in layout footer.
 * User-facing product does not show dev/prod environment.
 * REACT_APP_VERSION is set at build time by deploy scripts.
 */
const AppVersion = () => {
  const version = process.env.REACT_APP_VERSION || '0.9.3';
  return (
    <Text fontSize="xs" color="gray.400" title={`Version ${version}`}>
      v{version}
    </Text>
  );
};

export default AppVersion;
